import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation, useNavigate } from 'react-router-dom';
import { scroller } from 'react-scroll';

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Cierra el Drawer si cambia a escritorio
  useEffect(() => {
    if (!isMobile && drawerOpen) {
      setDrawerOpen(false);
    }
  }, [isMobile, drawerOpen]);

  const handleNavigation = (item) => {
    if (item.to.startsWith('/')) {
      navigate(item.to);
    } else {
      if (isHome) {
        scroller.scrollTo(item.to, { smooth: true, duration: 800, offset: -70 });
      } else {
        navigate('/');
        setTimeout(() => scroller.scrollTo(item.to, { smooth: true, duration: 800, offset: -70 }), 500);
      }
    }
    setDrawerOpen(false); // cierre seguro
  };

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setDrawerOpen(false);
  };

const guestMenu = [
  { label: 'Herramienta', to: 'que-es' },
  { label: 'Funcionalidades', to: 'funcionalidades' },
  { label: 'Beneficios', to: 'beneficios' },
  { label: 'Planes', to: 'planes' },
  { label: 'Contacto', to: 'contacto' },
];


  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          bgcolor: '#ffffff',
          color: '#0a1929',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.08)',
          borderRadius: '0 0 20px 20px',
          transition: 'all 0.3s ease',
          zIndex: 1201,
          px: { xs: 1.5, md: 2 },
        }}
      >
        <Toolbar
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '1160px',
    mx: 'auto',
    width: '100%',
    minHeight: { xs: 62, md: 66 },
    py: { xs: 0.6, md: 0.8 },
  }}
>
          {/* Logo */}
          <Box
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            onClick={handleLogoClick}
          >
            <img
              src="/images/logo_simbolo.png"
              alt="UNE Logo"
              style={{ width: '38px', height: '45px', marginRight: '9px' }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                fontSize: '1.28rem',
                color: '#0a1929',
                fontFamily: `'Montserrat', sans-serif`,
              }}
            >
              DQPa
            </Typography>
          </Box>

          {/* Desktop Menu */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
            {guestMenu.map((item, i) => (
              <Button
                key={i}
                onClick={() => handleNavigation(item)}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  mx: 1,
                  color: '#1a202c',
                  fontSize: '0,92rem',
                  '&:hover': { color: '#d37d36', bgcolor: 'transparent' },
                }}
              >
                {item.label}
              </Button>
            ))}
            <Button
              onClick={() => {
                navigate('/login');
                setDrawerOpen(false);
              }}
              sx={{
                textTransform: 'none',
                border: '1px solid #1e4b81',
                color: '#1e4b81',
                fontWeight: 'bold',
                fontSize: '0.89rem',
                ml: 2,
                px: 2,
                borderRadius: '10px',
                '&:hover': { backgroundColor: '#f0f4fa' },
              }}
            >
              Identificarse
            </Button>
            <Button
              onClick={() => {
                navigate('/register');
                setDrawerOpen(false);
              }}
              sx={{
                textTransform: 'none',
                backgroundColor: '#1e4b81',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '0.84rem',
                ml: 2,
                px: 2,
                borderRadius: '10px',
                '&:hover': { backgroundColor: '#153a66' },
              }}
            >
              Comenzar Evaluación
            </Button>
          </Box>

          {/* Mobile Menu Button */}
          <IconButton
  edge="start"
  color="inherit"
  aria-label="menu"
  sx={{ display: { xs: 'block', md: 'none' } }}
  onClick={() => setDrawerOpen(prev => !prev)}
>
  <MenuIcon />
</IconButton>

        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile */}
      <Drawer
        anchor="top"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: '100%',
            bgcolor: '#ffffff',
            px: 3,
            py: 2,
          },
        }}
      >
        <Box>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ mb: 2, textAlign: 'center' }}
          >
            Menú
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <List>
            {guestMenu.map((item, index) => (
              <ListItem disablePadding key={index}>
                <ListItemButton
                  onClick={() => handleNavigation(item)}
                >
                  <ListItemText
                    primary={item.label}
                    sx={{ textAlign: 'center', fontWeight: 'bold' }}
                  />
                </ListItemButton>
              </ListItem>
            ))}

            <Divider sx={{ my: 2 }} />

            {/* Demo Button */}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate('/login');
                  setDrawerOpen(false);
                }}
                sx={{ justifyContent: 'center' }}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  sx={{
                    border: '1px solid #1e4b81',
                    color: '#1e4b81',
                    fontWeight: 'bold',
                    borderRadius: '10px',
                    textTransform: 'none',
                    py: 1,
                  }}
                >
                  Demo Gratuita
                </Button>
              </ListItemButton>
            </ListItem>

            {/* Eval Button */}
            <ListItem disablePadding sx={{ mt: 1 }}>
              <ListItemButton
                onClick={() => {
                  navigate('/evaluacion');
                  setDrawerOpen(false);
                }}
                sx={{ justifyContent: 'center' }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: '#1e4b81',
                    color: '#ffffff',
                    fontWeight: 'bold',
                    borderRadius: '10px',
                    textTransform: 'none',
                    py: 1,
                    '&:hover': { backgroundColor: '#153a66' },
                  }}
                >
                  Comenzar Evaluación
                </Button>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;
